import './ToDosError.css'

function ToDosError() {
    return(
        <p> Error! </p>
    )
}

export { ToDosError };